/* permittedCharacter(String): It is a string that contains the characters that are not allowed to be entered in the text field.The Characters should be enclosed in square brackets. 
    For example, if you want to restrict the characters %, <, >, $, ', " then the permittedCharacter string should be "[<%$'"]", '^[a-zA-Z0-9]+$' for all special characters and space
*/
/* permittedCharacter(String): It is a RegularExpression string that contains the characters that are allowed to be entered in the text field.The Characters should be enclosed in square brackets. 
    For example, if you want only alphanumeric  and underscore then the permittedCharacter string should be '^[a-zA-Z0-9_]*$', '^[a-zA-Z0-9]+$' 
    Another example if first character to be only alphabet and rest can be alphanumeric then the permittedCharacter string should be "^[a-zA-Z][a-zA-Z0-9]*$"
*/

import React, { useEffect } from "react";
import "../../cssfiles/homepage.css";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import InputAdornment from '@mui/material/InputAdornment';
import { Box, Button, Dialog,DialogContent,DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import LK_ArrowDown from '../../images/LK_ArrowDown';
import LK_ArrowUp from '../../images/LK_ArrowUp';

export default function CustomNumberField({
  id,
  defaultValue,
  width,
  fontSize,
  disabled,
  maxLength,
  onChange,
  placeholder,
  permittedCharacters,
  min,
  incrementDecrementFactor,
  maxValueLimit,
  minValueLimit,
}) {
  const themechange = useSelector((state) => state.themedata.theme);
  const [val, setval] = React.useState("");
  const [error, setError] = React.useState("");
  // const [permittedCharacter1, setPermittedCharacter] = React.useState("");
  const permittedCharacter = new RegExp('^[0-9]+(\.[0-9]*)?$');
  const errorText = "Only numeric values are allowed";
  // const permittedCharacter1 = new RegExp('^[a-zA-Z][a-zA-Z0-9_]*$');
  // console.log("permittedCharacter1", permittedCharacter1);

  useEffect(() => {
    setval(defaultValue);
  }, [defaultValue]);

  // useEffect(() => {
  //   {
  //     let re = new RegExp(permittedCharacters);
  //     setPermittedCharacter(re);
  //   }
  // }, [permittedCharacters]);


  console.log("val at custom number fieldpp", maxValueLimit,",pp", minValueLimit,", incrementDecrementFactor", incrementDecrementFactor);

  function handleIncrement(e) {
    console.log("increment factor", incrementDecrementFactor);
    if(val !== ""){
      console.log("increment factor", incrementDecrementFactor);
      if(incrementDecrementFactor!==undefined){
        const newValue = parseFloat(val) + parseFloat(incrementDecrementFactor);
        // setval(newValue.toString());
        // onChange(newValue.toString());
        if(maxValueLimit !== undefined && maxValueLimit !== null && newValue > parseFloat(maxValueLimit)){
          setError(`Value should not be greater than ${maxValueLimit}`);
        } else{ 
          setval(newValue);
          onChange(newValue,e);
          setError("");
        }  
      }else{
        //by default will increment by 1 if increment factor is not provided
        const newValue = parseFloat(val) + 1;
        if(maxValueLimit !== undefined && maxValueLimit !== null && newValue > parseFloat(maxValueLimit)){
          setError(`Value should not be greater than ${maxValueLimit}`);
        }else{
          setval(newValue);
          onChange(newValue,e);
          setError("");
        }
      }
    }
  }

  function handleDecrement(e) {
     console.log("increment factor", incrementDecrementFactor);
    if(val !== ""){
      console.log("increment factor", incrementDecrementFactor);
      if(incrementDecrementFactor!==undefined){
        const newValue = parseFloat(val) - parseFloat(incrementDecrementFactor);
        if(minValueLimit !== undefined && minValueLimit !== null &&newValue < parseFloat(minValueLimit)){
          setError(`Value should not be less than ${minValueLimit}`);
        } else{
          setval(newValue);
          onChange(newValue,e);
          setError("");
        }
      }else{
        //by default will decrement by 1 if increment factor is not provided
        const newValue = parseFloat(val) - 1;
        if(minValueLimit !== undefined && minValueLimit !== null &&newValue < parseFloat(minValueLimit)){
          setError(`Value should not be less than ${minValueLimit}`);
        } else{   
          setval(newValue);
          onChange(newValue,e);
          setError("");
        }
      }
    }
  }

  {console.log("permittedCharacter", permittedCharacter);}
  return (
    <TextField
      id={id}
      //type= {'number'}
      defaultValue={defaultValue ? defaultValue : null}
      disabled={disabled != null ? disabled : false}
      required
      placeholder={placeholder ? placeholder : null}
      value={val}
      variant="standard"
      helperText={error} // error message
      error={error} // set to true to change the border/helperText color to red !newValue.match(permittedCharacter)
      onChange={(e) => {
        const newValue = e.target.value;
        console.log("new value at custom number field", newValue,typeof(e.target.value));
          if (newValue.length != 0) {
            if (permittedCharacter.test(newValue)) {
              // setError("");
              // setName(newValue); // only set when successful
              if(maxValueLimit !== undefined && maxValueLimit !== null && parseFloat(newValue) > parseFloat(maxValueLimit)){
                setError(`Value should not be greater than ${maxValueLimit}`);
              } else if(minValueLimit !== undefined && minValueLimit !== null && parseFloat(newValue) < parseFloat(minValueLimit)){
                setError(`Value should not be less than ${minValueLimit}`);
              } else {
                setval(e.target.value);
                onChange(parseFloat(e.target.value), e);
                setError("");
              }
            } else {
              setError(errorText);
            }
          } else {
            setval(e.target.value);
            onChange(parseFloat(e.target.value), e);
          }
      }}
      //label="Label"
      inputProps={{ maxLength: maxLength ? maxLength : 250 ,min: min!==undefined ? min :null }}
      InputProps={{endAdornment: (
                    <InputAdornment position="end">
                        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap:'2px'}}>
                            <Button id={id} sx={{minWidth:'8px',minHeight:'8px',padding:0}} disabled={disabled === true} onClick={handleIncrement}><LK_ArrowUp color= {disabled === true ? themechange === "light"  ? "#C1C1C1"  : "#3C3C3C": "var(--HighlightedText_Stroke)"} width={"8px"} height={"8px"}/></Button>
                            <Button id={id} sx={{minWidth:'8px',minHeight:'8px',padding:0}} disabled={disabled === true} onClick={handleDecrement}><LK_ArrowDown color= {disabled === true ? themechange === "light"  ? "#C1C1C1"  : "#3C3C3C": "var(--HighlightedText_Stroke)"} width={"8px"} height={"8px"}/></Button>
                        </Box>
                    </InputAdornment>
                  )}}
      sx={{
        width: width ? width : "94px",
        "& .MuiInputBase-input:focus": {
          color: "#008CD7",
        },
        "& .MuiInputBase-root": {
          fontFamily: "Roboto",
          fontSize: fontSize ? `${fontSize}px` : "16px",
          fontWeight: "700",
          color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
          //color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: themechange === "light" ? "#C1C1C1" : "#3C3C3C",
          //WebkitBorderFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',
        },
        // '& .MuiInput-underline.Mui-disabled':{
        //     color: themechange === 'light' ? '#C1C1C1' : '#pink',
        // },
        "& .MuiInput-root .MuiInputBase-input": {
          padding: 0,
        },
        "& .MuiInputBase-root::before": {
          //borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
          borderBottom: `1px solid ${
            (disabled != null ? disabled : false) == true
              ? themechange === "light"
                ? "#C1C1C1"
                : "#3C3C3C"
              : themechange === "light"
              ? "#3C3C3C"
              : "#C1C1C1"
          }`,
        },
        "& ::-webkit-input-placeholder": {
          color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
        },
        "& .MuiInputBase-root::after": {
          borderBottom: "2px solid #008CD7",
        },
        "& .Mui-error": {
          color: "var(--RedBaseColor)",
        },
      }}
    />
  );
}
